import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";


export const llmModelsApiSlice = createApi({
    reducerPath: 'llmModelsApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getLlmModels: builder.query<string[], void>({
            query: () => ({
                url: `Llms`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
    }),
})

const {
    useGetLlmModelsQuery,
} = llmModelsApiSlice
export const llmModelsApiActions = {
    useGetLlmModelsQuery,
}